import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        // ns-p-1
        <span
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" class="icon icon-close icon" fill="none" xmlns="http://www.w3.org/2000/svg" role="graphics-symbol" focusable="false">
                <title>Close</title>
                <path d="M7 7L17 17M7 17L17 7" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </span>
    )
}

export default function SelectedFilters({isMobile}) {
    const { filters, removeAll } = useProductFilters()
    
    console.log('filters', filters);

    return (
        filters.length > 0 && (
            // 
            <div class="ns-d-flex ns-flex-wrap ns-flex-column ns-flex-md-row ns-align-items-start ns-align-items-md-center ns-pt-2 ns-pb-2 ns-selected-filters-container">
                <div class="ns-col-20 ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        // ns-font-4 ns-px-1 ns-mr-1 ns-mb-1
                        <div class="ns-selected-filter ns-d-flex ns-align-items-center">
                            {/* {filter.name}: */}
                            {filter?.field === "customFields.custom-colour_swatch" ? <span
                                style={{
                                backgroundImage: `url(${filter?.value})`, 
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                display: "inline-block", 
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                marginLeft: "11px",
                                marginRight: "2px"
                                }}
                            ></span> : <span class="ns-color-black">
                                {filter.value}
                            </span>}
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                {isMobile && <a href="javascript:void(0)" class="active-filters__clear" onClick={() => {
                        removeAll()
                    }}>clear all</a> }
            </div>
        )
    )
}

